// @ts-nocheck
// TODO: tighten types after migration
import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { API_ENDPOINTS } from '../../config/api';
import './KnowMe.css';

const getSocialIcon = (title, url) => {
    const t = (title || '').toLowerCase();
    const u = (url || '').toLowerCase();
    if (t.includes('instagram') || u.includes('instagram.com')) return <i className="fi fi-brands-instagram"></i>;
    if (t.includes('threads') || u.includes('threads.net')) return <i className="fi fi-brands-threads"></i>;
    if (t.includes('twitter') || t.includes('x.com') || u.includes('twitter.com') || u.includes('x.com')) return <i className="fi fi-brands-twitter-alt"></i>;
    if (t.includes('facebook') || u.includes('facebook.com')) return <i className="fi fi-brands-facebook"></i>;
    if (t.includes('youtube') || u.includes('youtube.com') || u.includes('youtu.be')) return <i className="fi fi-brands-youtube"></i>;
    return null;
};

function KnowMePublic() {
    const { username } = useParams();
    const [profile, setProfile] = useState(null);
    const [links, setLinks] = useState([]);
    const [loading, setLoading] = useState(true);
    const [notFound, setNotFound] = useState(false);

    useEffect(() => {
        const fetchProfile = async () => {
            try {
                const res = await fetch(API_ENDPOINTS.KNOWME.PUBLIC(username));
                if (!res.ok) { setNotFound(true); setLoading(false); return; }
                const data = await res.json();
                setProfile(data.profile);
                setLinks(data.links || []);
            } catch (err) {
                setNotFound(true);
            }
            setLoading(false);
        };
        fetchProfile();
    }, [username]);

    const handleClick = async (link) => {
        try { fetch(API_ENDPOINTS.KNOWME.CLICK(link._id), { method: 'POST' }); } catch (e) { /* ignore */ }
        window.open(link.url, '_blank', 'noopener');
    };

    if (loading) return <div className="km-loading mx-auto my-[2rem] w-[min(95%,760px)] rounded-[12px] border border-slider bg-bg p-[24px] text-center">Loading...</div>;
    if (notFound) return (
        <div className="km-public-not-found mx-auto my-[2rem] flex w-[min(95%,760px)] flex-col items-center rounded-[12px] border border-slider bg-bg p-[24px] text-center">
            <i className="fi fi-rr-link"></i>
            <h2>Page not found</h2>
            <p>This Know Me page doesn't exist yet.</p>
        </div>
    );

    const btnRadius = profile?.buttonStyle === 'pill' ? '9999px' : profile?.buttonStyle === 'square' ? '0' : '12px';

    return (
        <>
            <Helmet>
                <title>{profile?.displayName || profile?.username || 'Know Me'} | Hari Vishnu</title>
                <meta name="description" content={profile?.bio || `${profile?.displayName || profile?.username}'s links`} />
                <meta name="robots" content="noindex,nofollow" />
            </Helmet>

            <div className="km-public-page min-h-screen p-[16px]" style={{ backgroundColor: profile?.backgroundColor || '#d2e823' }}>
                <div className="km-public-card mx-auto flex w-[min(96%,560px)] flex-col items-center rounded-[18px] border border-black/10 bg-white/60 p-[18px] backdrop-blur">
                    <div className="km-public-avatar flex h-[86px] w-[86px] items-center justify-center overflow-hidden rounded-full border-[3px]" style={{ borderColor: profile?.buttonColor || '#1a3a1a' }}>
                        {profile?.avatarUrl
                            ? <img src={profile.avatarUrl} alt="" />
                            : <span className="text-[2rem] font-[800]" style={{ color: profile?.buttonColor }}>{(profile?.displayName || profile?.username || '?')[0]?.toUpperCase()}</span>
                        }
                    </div>
                    <h1 className="km-public-name mt-[10px] text-[1.6rem] font-[800]" style={{ color: profile?.buttonColor }}>
                        {profile?.displayName || profile?.username}
                    </h1>
                    {profile?.bio && <p className="km-public-bio mt-[6px] text-center text-[0.95rem]" style={{ color: profile?.buttonColor, opacity: 0.7 }}>{profile.bio}</p>}

                    <div className="km-public-links mt-[14px] flex w-full flex-col gap-[8px]">
                        {links.map(link => (
                            <button key={link._id} className="km-public-link-btn w-full rounded-[12px] border border-black/10 px-[14px] py-[10px] text-left font-[700] shadow-sm" onClick={() => handleClick(link)}
                                style={{ backgroundColor: profile?.buttonColor, color: profile?.buttonFontColor, borderRadius: btnRadius }}>
                                <div className="flex items-center justify-center gap-[8px]">
                                    {getSocialIcon(link.title, link.url)}
                                    <span>{link.title}</span>
                                </div>
                            </button>
                        ))}
                    </div>

                    <div className="km-public-footer mt-[14px]">
                        <span style={{ color: profile?.buttonColor, opacity: 0.4 }}>Know Me</span>
                    </div>
                </div>
            </div>
        </>
    );
}

export default KnowMePublic;
